var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analytics-wrapper-cards-footer"},[_c('router-link',{staticClass:"analytics-cards-footer",attrs:{"aria-label":("Go to " + _vm.name + " detailed Report"),"to":_vm.link}},[_vm._v(" Go to detailed Report ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }